module.exports = __webpack_public_path__ + "img/footer-icon-row-light-nissan.4eeebd99.png";